import { random } from "lodash";
import { useCallback } from "react";
import { Slider } from "@radix-ui/themes";
import CreateCharacterBtnRandom from "@/domains/createCharacter/components/CreateCharacterBtnRandom";

type Props = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  hasRandom?: boolean;
};

export default function CreateCharacterRange({
  label,
  value,
  onChange,
  min = 0,
  max = 1,
  step = 0.01,
  hasRandom = false,
}: Props) {
  const handleValueChange = useCallback(
    (v: number[]) => {
      const newValue = v[0];
      if (newValue !== value) {
        onChange(newValue);
      }
    },
    [onChange],
  );

  return (
    <div className="bg-dark-800 shrink-0 gap-px flex justify-between items-center rounded-xl h-13.5 pl-4 pr-2">
      <div className="font-bold mr-auto text-15">{label}</div>
      <div className="w-[12rem] shrink-0 flex items-center gap-2 px-3 font-medium text-sm">
        <Slider
          variant="soft"
          min={min}
          max={max}
          step={step}
          value={[value]}
          onValueChange={handleValueChange}
        />
      </div>
      {hasRandom && (
        <CreateCharacterBtnRandom
          onClick={() => {
            onChange(random(min, max, true));
          }}
        />
      )}
      <div className="h-full w-13  rounded-r-xl text-sm font-bold  flex items-center justify-center shrink-0 whitespace-nowrap text-center tabular-nums">
        {(value * 100).toFixed(0)}%
      </div>
    </div>
  );
}
